import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import YouTubeLite from './YouTubeLite';

export default function VSL() {
  return (
    <section className="ob-dark-section bg-[var(--ob-dark)] py-24 md:py-32">
      <div className="mx-auto max-w-[1160px] px-5 md:px-8">
        <Reveal className="mb-12 text-center">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent)]">
            Watch The Full Story
          </p>
          <h2 className="mx-auto max-w-3xl font-display text-4xl font-extrabold tracking-tight text-white md:text-6xl">
            Hear it straight from the founder.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg text-white/60">
            A short video on why OnBrand is one of the highest-quality email &amp; SMS teams in the
            ecommerce industry.
          </p>
        </Reveal>

        <Reveal>
          <div className="relative">
            {/* Main VSL: large, prominent, click-to-load YouTube */}
            <div className="ob-email-card relative aspect-video w-full overflow-hidden rounded-[1.75rem] border border-white/10 bg-[var(--ob-dark)] shadow-2xl">
              <YouTubeLite videoId="_7ctSpXeH-k" title="Welcome to OnBrand Emails" size="lg" />
            </div>
            {/* subtle accent glows for prominence */}
            <div className="pointer-events-none absolute -left-10 -top-10 -z-10 h-48 w-48 rounded-full bg-[var(--ob-accent)]/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-10 -right-10 -z-10 h-48 w-48 rounded-full bg-[var(--ob-accent)]/20 blur-3xl" />
          </div>
        </Reveal>

        <Reveal className="mt-10 text-center">
          <a
            href="https://calendly.com/hello-onbrandadmin/30min" target="_blank" rel="noopener noreferrer"
            className="ob-btn group inline-flex items-center gap-2 rounded-full bg-[var(--ob-accent)] px-10 py-5 text-lg font-bold text-[var(--ob-dark)] hover:bg-white"
          >
            Get A Free Strategy Audit
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
